import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { GlobalSearchStateContext, GlobalSearchDispatchContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import useMerchandiseSearchTypeahead from 'hooks/Merchandise/useMerchandiseSearchTypeahead'
import useDebouncedCallback from 'hooks/useDebouncedCallback'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import SearchFormTextField from '../../SearchFormField/SearchFormTextField'
import MerchandiseSearchFormPlaceholderResults from 'components/Merchandise/MerchandiseSearch/MerchandiseSearchFormPlaceholderResults'
import MerchandiseSearchFormResults from 'components/Merchandise/MerchandiseSearch/MerchandiseSearchFormResults'
import MerchandiseSearchFormNoResults from 'components/Merchandise/MerchandiseSearch/MerchandiseSearchFormNoResults'

function SearchV2MerchandiseTabContent() {
  const intl = useIntl()
  const {
    searchItem,
  } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const debounceChange = useDebouncedCallback((text: string) => {
    if (!text) {
      searchDispatch({ type: GlobalSearchStateActions.UNSET_SEARCH_ITEM })
    }
    const nextSearchItem: App.SearchMerchandise = {
      searchType: 'merchandise',
      value: text,
      format: {
        mainText: text,
      },
    }
    searchDispatch({ type: GlobalSearchStateActions.SET_SEARCH_ITEM, searchItem: nextSearchItem })
  }, 500, [])

  const onSearchChange = useCallback<React.ChangeEventHandler<HTMLInputElement>>((e) => {
    debounceChange(e.target.value)
  }, [debounceChange])

  const [results, loading] = useMerchandiseSearchTypeahead(searchItem?.value ?? '')

  const onClear = useCallback(() => {
    searchDispatch({ type: GlobalSearchStateActions.UNSET_SEARCH_ITEM })
  }, [searchDispatch])

  const hasResults = !!results.products.length || !!results.categories.length || !!results.brands.length

  return <VerticalSpacer gap={20}>
    <SearchFormTextField
      placeholder={intl.formatMessage({
        id: 'tTcDNylTyVAPOI5vgP64',
        defaultMessage: 'Search products, categories or brands',
        description: 'Placeholder for merchandise search text field on the form',
      })}
      onChange={onSearchChange}
      defaultValue={searchItem?.value}
      displayValue={searchItem?.value}
      autoComplete="off"
      name="search"
      onClear={onClear}
    />
    {!searchItem && <MerchandiseSearchFormPlaceholderResults />}
    {searchItem && searchItem.value.length > 0 && <>
      {!loading && !hasResults && <MerchandiseSearchFormNoResults text={searchItem.value} />}
      {(loading || hasResults) && <MerchandiseSearchFormResults
        results={results}
        text={searchItem?.value ?? ''}
        loading={loading}
      />}
    </>}
  </VerticalSpacer>
}

export default SearchV2MerchandiseTabContent
